export { default as ProductsElasticSearchCategoriesNav } from './ProductsElasticSearchCategoriesNav';
